import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { OpeneconomicsLogo } from 'loghi';
import moment from 'moment';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import { Link, useLocation } from 'react-router-dom';
import NewBrand from './NewBrand/NewBrand';

function Footer() {
	const location = useLocation();
	const isRoot = location.pathname === '/';
	const routesWithShortFooter = ['/dpa'];
	const hasShortFooter = routesWithShortFooter.includes(location.pathname);
	return (
		<footer
			id="site-footer"
			style={{
				display: isRoot ? 'none' : 'block',
			}}
		>
			<Container>
				<Row>
					<Col
						className="text-center"
						{...(hasShortFooter
							? {
									style: {
										display: 'flex',
										alignItems: 'center',
										gap: '1rem',
									},
								}
							: {})}
					>
						{window.location.pathname !== '/login' && (
							<>
								{/* eslint-disable-next-line react/jsx-no-target-blank */}
								<a href="https://www.openeconomics.eu/" target="_blank" alt="OpenEconomics" title="OpenEconomics">
									<div className="mt-4 mb-3">
										<small>Powered by</small>
										<OpeneconomicsLogo
											style={{
												marginLeft: '1rem',
											}}
											// className="openeconomicslogo"
											// style={{ height: '25px', marginLeft: '0.7rem', marginBottom: '0.2rem' }}
										/>
									</div>
								</a>
							</>
						)}
						<div className={`copyright mb-3 ${hasShortFooter ? 'mt-4' : ''}`.trim()}>
							© {moment().format('Y')} Copyright OpenEconomics | Vat 12504821005
						</div>
						<div
							className={`mb-3 ${hasShortFooter ? 'mt-4' : ''}`.trim()}
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '0.5rem',
							}}
						>
							<PrivacyPolicy />
							<span>|</span>
							<Link
								className="btn custom-ghost-button"
								style={{
									color: '#666666',
									textTransform: 'none',
									fontWeight: 400,
									textDecoration: 'underline',
								}}
								to="/dpa"
								target="_blank"
							>
								DPA
							</Link>
							<span>|</span>
							<NewBrand />
							{/* <Link
								to="/new-brand"
								className="btn custom-ghost-button"
								style={{
									color: '#666666',
									textTransform: 'none',
									fontWeight: 400,
									textDecoration: 'underline',
								}}
							>
								Benvenuto in Sonar
							</Link> */}
						</div>
					</Col>
				</Row>
			</Container>
		</footer>
	);
}

export default Footer;
